import { useState } from 'react';
import { useQuery } from 'react-query';
import axiosClient from '@lib/utils/axiosClient';

const fetchDownloads = async (url: string) => {
  const response = await axiosClient.get(url);
  return response.data;
};

const useFileDownload = (endpoint: string) => {
  const [enabled, setEnabled] = useState(false);

  const query = useQuery('downloads', () => fetchDownloads(endpoint), {
    enabled,
  });

  return {
    ...query,
    enabled,
    setEnabled,
  };
};

export default useFileDownload;
